<template>
  <el-dialog
    :title="$t('indexMenu.edit.title')"
    :visible.sync="visible"
    width="50%"
    @close="handleClose"
  >
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item
        :label="$t('indexMenu.form.name')"
        prop="name"
      >
        <el-input
          v-model="formData.name"
          :placeholder="$t('indexMenu.form.namePlaceholder')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('indexMenu.form.logo')"
        prop="menuIcon"
      >
        <upload-image-url
          ref="uploadImage"
          :image-count="1"
          :initial-images="[formData.menuIcon]"
          @notifyUploadCoverImage="handleImageChange"
        />
      </el-form-item>

      <el-form-item
        :label="$t('indexMenu.form.seq')"
        prop="seq"
      >
        <el-input
          v-model="formData.seq"
          :placeholder="$t('indexMenu.form.seqPlaceholder')"
        />
      </el-form-item>

      <el-form-item
        :label="$t('indexMenu.form.isShow')"
        prop="isShow"
      >
        <el-select
          v-model="formData.isShow"
          style="width:100%"
          :placeholder="$t('indexMenu.form.isShowPlaceholder')"
        >
          <el-option
            v-for="item in isShowOptions"
            :key="item.statusCd"
            :label="item.name"
            :value="item.statusCd"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="handleSubmit"
        :loading="loading"
      >
        {{ $t('common.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateShopMenu } from '@/api/phone/indexMenuApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'

export default {
  name: 'EditIndexMenu',
  components: {
    UploadImageUrl
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: {
        menuId: '',
        name: '',
        menuIcon: '',
        seq: '',
        isShow: '',
        shopId: ''
      },
      rules: {
        name: [
          { required: true, message: this.$t('indexMenu.validate.nameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('indexMenu.validate.nameMaxLength'), trigger: 'blur' }
        ],
        menuIcon: [
          { required: true, message: this.$t('indexMenu.validate.logoRequired'), trigger: 'change' }
        ],
        seq: [
          { required: true, message: this.$t('indexMenu.validate.seqRequired'), trigger: 'blur' },
          { type: 'number', message: this.$t('indexMenu.validate.seqNumber'), trigger: 'blur', transform: value => Number(value) }
        ],
        isShow: [
          { required: true, message: this.$t('indexMenu.validate.isShowRequired'), trigger: 'change' }
        ],
        menuId: [
          { required: true, message: this.$t('indexMenu.validate.menuIdRequired'), trigger: 'blur' }
        ]
      },
      isShowOptions: [],
      shopId: ''
    }
  },
  methods: {
    open(row) {
      this.shopId = getShopId()
      this.getDictData()
      this.formData = {
        ...row,
        shopId: this.shopId
      }
      this.visible = true
      this.$nextTick(() => {
        if (this.$refs.uploadImage) {
          this.$refs.uploadImage.clearImages()
          if (row.menuIcon) {
            this.$refs.uploadImage.setImages([row.menuIcon])
          }
        }
      })
    },
    async getDictData() {
      try {
        const data = await getDict('housekeeping_type', 'is_show')
        this.isShowOptions = data.data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleImageChange(images) {
      if (images && images.length > 0) {
        this.formData.menuIcon = images[0]
      } else {
        this.formData.menuIcon = ''
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return

        try {
          this.loading = true
          await updateShopMenu(this.formData)
          this.$message.success(this.$t('indexMenu.edit.success'))
          this.$emit('success')
          this.visible = false
        } catch (error) {
          this.$message.error(this.$t('indexMenu.edit.error'))
        } finally {
          this.loading = false
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>